import React, { useEffect, useState } from 'react'
import {
  Box,
  Grid,
} from '@mui/material'

import { useSelector } from 'react-redux'
import { useLocation } from 'react-router-dom'
import TutorialModal from '../../components/TutorialModal'

// Sub-components
import DashboardHeader from './components/DashboardHeader'
import {
  ContractDataProvider,
  ContractActionCards,
  ContractRecentWork,
} from './components/ContractCharts'
import DataSourcesList from './components/DataSourcesList'
import LegalNewsWidget from './components/LegalNewsWidget'
import AnnoncesWidget from './components/AnnoncesWidget'
import MonitoringCards from './components/MonitoringCards'
import PipelineFunnel from './components/PipelineFunnel'
import PartyIntelligence from './components/PartyIntelligence'

// ─── Main Component ──────────────────────────────────────────────────────────

const DashboardScreen = () => {
  const location = useLocation()
  const user = useSelector((state) => state.auth.user?.user)

  // Tutorial modal
  const [openModal, setOpenModal] = useState(
    location?.state?.openModal || false
  )

  useEffect(() => {
    const modalClosed = JSON.parse(localStorage.getItem('modalClosed'))
    if (!modalClosed) setOpenModal(true)
  }, [])

  const handleCloseModal = () => {
    setOpenModal(false)
    localStorage.setItem('modalClosed', true)
  }

  return (
    <Box
      sx={{
        py: { xs: 2, sm: 3 },
        px: { xs: 2, sm: 2 },
        overflow: 'auto',
        '&::-webkit-scrollbar': {
          display: 'none',
        },
        msOverflowStyle: 'none',
        scrollbarWidth: 'none',
      }}
    >
      {/* Header */}
      <DashboardHeader user={user} onOpenTutorial={() => setOpenModal(true)} />

      <ContractDataProvider>
        {/* 1. Pipeline Funnel — full width */}
        <Box sx={{ mb: 2.5 }}>
          <PipelineFunnel />
        </Box>

        {/* 3. Action cards — full width, 3 columns */}
        <Box sx={{ mb: 2.5 }}>
          <ContractActionCards />
        </Box>

        {/* 4. Monitoring summary cards */}
        <Box sx={{ mb: 2.5 }}>
          <MonitoringCards />
        </Box>

        {/* 5. Recent contracts (7/12) + Party Intelligence (5/12) */}
        <Grid container spacing={2.5} sx={{ mb: 2.5 }}>
          <Grid data-tour="contract-recent-work" item xs={12} md={7}>
            <ContractRecentWork />
          </Grid>
          <Grid item xs={12} md={5}>
            <PartyIntelligence />
          </Grid>
        </Grid>

        {/* 6. Legal News (5/12) + Annonces Légales (7/12) */}
        <Grid container spacing={2.5} sx={{ mb: 2.5 }}>
          <Grid data-tour="legal-news-widget" item xs={12} md={5}>
            <LegalNewsWidget />
          </Grid>
          <Grid data-tour="annonces-widget" item xs={12} md={7}>
            <AnnoncesWidget />
          </Grid>
        </Grid>
      </ContractDataProvider>

      {/* 7. Data Sources — full width */}
      <Grid container spacing={2.5}>
        <Grid item xs={12} md={6}>
          <DataSourcesList />
        </Grid>
      </Grid>

      {/* Tutorial modal */}
      <TutorialModal open={openModal} onClose={handleCloseModal} />
    </Box>
  )
}

export default DashboardScreen
